import React, { createContext, useContext, useEffect } from "react";
import PropTypes from "prop-types";

export const ErrorHandlingContext = createContext();

export const useFrontendAPIErrorEffect = (errors) => {
  const errorHandler = useContext(ErrorHandlingContext);
  useEffect(() => {
    if (errors) {
      errorHandler.dispatchFrontendAPIError(errors);
    }
  });
};

export default function ErrorHandlingProvider({ errorHandler, children }) {
  return (
    <ErrorHandlingContext.Provider value={errorHandler}>
      {children}
    </ErrorHandlingContext.Provider>
  );
}

ErrorHandlingProvider.propTypes = {
  errorHandler: PropTypes.shape({
    dispatchRenderError: PropTypes.func.isRequired,
    dispatchFrontendAPIError: PropTypes.func.isRequired,
  }),
  children: PropTypes.node,
};
